export default function MatchIcon(props) {
  return (
    <svg
      width='28px'
      height='28px'
      viewBox='0 0 28 28'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <g
          id='Vector'
          transform='translate(1.000000, 1.000000)'
          stroke='#3D7BF3'
          strokeWidth='2'
        >
          <path
            d='M13.5799,0.82986 C13.0485,1.36121 12.75,2.08188 12.75,2.83333 L12.75,4.25 C12.75,4.62572 12.6007,4.98605 12.3351,5.25173 C12.0694,5.51741 11.7091,5.66666 11.3333,5.66666 L7.08333,5.66666 C6.70761,5.66666 6.34727,5.81592 6.08159,6.08159 C5.81592,6.34727 5.66666,6.70761 5.66666,7.08333 L5.66666,11.3333 C5.66666,11.7091 5.51741,12.0694 5.25173,12.3351 C4.98605,12.6007 4.62572,12.75 4.25,12.75 L2.83333,12.75 C2.08188,12.75 1.36121,13.0485 0.82986,13.5799 C0.29851,14.1112 -8.8817842e-16,14.8319 -8.8817842e-16,15.5833 C-8.8817842e-16,16.3348 0.29851,17.0554 0.82986,17.5868 C1.36121,18.1182 2.08188,18.4167 2.83333,18.4167 L4.25,18.4167 C4.62572,18.4167 4.98605,18.5659 5.25173,18.8316 C5.51741,19.0973 5.66666,19.4576 5.66666,19.8333 L5.66666,24.0833 C5.66666,24.4591 5.81592,24.8194 6.08159,25.0851 C6.34727,25.3507 6.70761,25.5 7.08333,25.5 L11.3333,25.5 C11.7091,25.5 12.0694,25.3507 12.3351,25.0851 C12.6007,24.8194 12.75,24.4591 12.75,24.0833 L12.75,22.6667 C12.75,21.9152 13.0485,21.1945 13.5799,20.6632 C14.1112,20.1318 14.8319,19.8333 15.5833,19.8333 C16.3348,19.8333 17.0554,20.1318 17.5868,20.6632 C18.1182,21.1945 18.4167,21.9152 18.4167,22.6667 L18.4167,24.0833 C18.4167,24.4591 18.5659,24.8194 18.8316,25.0851 C19.0973,25.3507 19.4576,25.5 19.8333,25.5 L24.0833,25.5 C24.4591,25.5 24.8194,25.3507 25.0851,25.0851 C25.3507,24.8194 25.5,24.4591 25.5,24.0833 L25.5,19.8333 C25.5,19.4576 25.3507,19.0973 25.0851,18.8316 C24.8194,18.5659 24.4591,18.4167 24.0833,18.4167 L22.6667,18.4167 C21.9152,18.4167 21.1945,18.1182 20.6632,17.5868 C20.1318,17.0554 19.8333,16.3348 19.8333,15.5833 C19.8333,14.8319 20.1318,14.1112 20.6632,13.5799 C21.1945,13.0485 21.9152,12.75 22.6667,12.75 L24.0833,12.75 C24.4591,12.75 24.8194,12.6007 25.0851,12.3351 C25.3507,12.0694 25.5,11.7091 25.5,11.3333 L25.5,7.08333 C25.5,6.70761 25.3507,6.34727 25.0851,6.08159 C24.8194,5.81592 24.4591,5.66666 24.0833,5.66666 L19.8333,5.66666 C19.4576,5.66666 19.0973,5.51741 18.8316,5.25173 C18.5659,4.98605 18.4167,4.62572 18.4167,4.25 L18.4167,2.83333 C18.4167,2.08188 18.1182,1.36121 17.5868,0.82986 C17.0554,0.29851 16.3348,-8.8817842e-16 15.5833,-8.8817842e-16 C14.8319,-8.8817842e-16 14.1112,0.29851 13.5799,0.82986 Z'
            id='Path'
          ></path>
        </g>
      </g>
    </svg>
  )
}
